import Vue from 'vue';
import { Module, ActionContext } from 'vuex';
import { TjipVuexMutation, TjipVuexAction, tjipSessionStore } from '@tjip/vuejs';
import * as _ from 'lodash';

export class AppSessionStoreDataModule<T, R> implements Module<T, R> {
  protected static metaKeys = ['_initialData', '_storeItem'];
  public namespaced = true;

  public state: T;

  constructor(private name: string, data: T) {
    const initialData = _.cloneDeep(data);
    this.state = data;
    const s = this.state as any;
    s._initialData = initialData;
    s._storeItem = tjipSessionStore.item(`ppf.customer-portal.data.${name}`);
  }

  @TjipVuexAction
  protected init(ctx: ActionContext<T, R>) {
    ctx.commit('restore');
    (this as any)._vm.$watch(
      () => ctx.state,
      (val: any) => {
        ctx.commit('store', val);
      },
      { deep: true }
    );
  }

  @TjipVuexAction
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected logout(ctx: ActionContext<T, R>) {
    return;
  }

  @TjipVuexAction
  protected reset(ctx: ActionContext<T, R>) {
    const initialData = (ctx.state as any)._initialData;
    ctx.commit('store', _.cloneDeep(initialData));
  }

  @TjipVuexMutation
  private store(state: T, payload: T) {
    const data = _.omit(payload as any, AppSessionStoreDataModule.metaKeys);
    if (_.isArray(state)) {
      Array.prototype.splice.call(state, 0, state.length, ...((payload as unknown) as any[]));
    } else {
      Object.assign(state, data);
    }
    const storeItem = (state as any)._storeItem;
    storeItem.set(data);
  }

  @TjipVuexMutation
  protected restore(state: T) {
    const storeItem = (state as any)._storeItem;
    const initialData = (state as any)._initialData;
    const newData = Object.assign(
      _.cloneDeep(initialData),
      (storeItem.get() as T) || _.omit(state as any, AppSessionStoreDataModule.metaKeys)
    );
    const observableData = Vue.observable(newData);
    if (_.isArray(state)) {
      Array.prototype.splice.call(state, 0, state.length, ...((observableData as unknown) as any[]));
    } else {
      Object.assign(state, observableData);
    }
  }
}
